import { useState, useEffect } from 'react';
import { doc, updateDoc, deleteDoc, query, collection, where, getDocs, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
//import { MailConfirmNotification } from '../../functions/MailConfirmNotification';
//import { MailDeleteNotification } from '../../functions/MailDeleteNotification';
import { ShowToast } from '../../functions/ShowToast';
import moment from 'moment';

import { DaysBetweenDates } from '../../functions/DaysBetweenDates';
import { Loader } from '../Loader';
import simpleClock from '../../assets/animations/simpleClock2.json';

const updateRecords = async (data) => {
  const absenceDays = DaysBetweenDates(moment(data.startDate, 'DD/MM/YYYY'), moment(data.endDate, 'DD/MM/YYYY'));

  let records = await getDoc(doc(db, 'users', data.uid, 'registros', moment(data.startDate, 'DD/MM/YYYY').format('MMMM-YYYY')));

  records = records.data();

  //Si absenceDays es mayor de 1 día
  if (absenceDays.length > 1) {
    //Si startDate y endDate son de diferente mes, obtener los meses entre ellos.
    if (moment(data.startDate, 'DD/MM/YYYY').format('MMMM-YYYY') !== moment(data.endDate, 'DD/MM/YYYY').format('MMMM-YYYY')) {
      let currentMonth = moment(data.startDate, 'DD/MM/YYYY').format('MMMM-YYYY');
      const endMonth = moment(data.endDate, 'DD/MM/YYYY').format('MMMM-YYYY');
      while (currentMonth !== endMonth) {
        currentMonth = moment(currentMonth, 'MMMM-YYYY').add(1, 'month').format('MMMM-YYYY');
        //concatena records con los registros del mes actual
        const currentRecords = await getDoc(doc(db, 'users', data.uid, 'registros', currentMonth));
        records = { ...records, ...currentRecords.data() };
      }
    }

    absenceDays.forEach(async (day) => {
      let record = records[day];
      if (record) {
        const lastIndex = Object.keys(record).length - 1;
        record = {
          ...record,
          [lastIndex]: {
            ...record[lastIndex],
            tpRegistro: data.type,
            totalAcumulado: '0:00',
          },
        };

        await updateDoc(doc(db, 'users', data.uid, 'registros', moment(day, 'DD/MM/YYYY').format('MMMM-YYYY')), {
          [day]: record,
        });
      }
    });
  } else {
    const dayRecords = records[data.startDate.replace(/\//g, '-')];
    if (dayRecords) {
      const lastIndex = Object.keys(dayRecords).length - 1;
      const updatedRecord = {
        ...dayRecords,
        [lastIndex]: {
          ...dayRecords[lastIndex],
          tpRegistro: data.type,
          totalAcumulado: '0:00',
        },
      };

      await updateDoc(doc(db, 'users', data.uid, 'registros', moment(data.startDate, 'DD/MM/YYYY').format('MMMM-YYYY')), {
        [data.startDate.replace(/\//g, '-')]: updatedRecord,
      });
    }
  }
};

export const ShowAbsences = (props) => {
  const [data, setData] = useState(null);
  const [observations, setObservations] = useState('');
  const [loading, setLoading] = useState(false);

  const existingRecords = data?.existingRecords;

  useEffect(() => {
    setData(props.data);
    setLoading(false);
  }, [props.data]);

  const confirmNotification = async (data) => {
    if (existingRecords?.length) {
      const msg =
        existingRecords.length === 1
          ? `El usuario ya tiene registros de fichaje en el día ${existingRecords[0]}. ¿Deseas aceptar la solicitud igualmente?`
          : `El usuario ya tiene registros de fichaje en los días ${existingRecords.join(', ')}. ¿Deseas aceptar la solicitud igualmente?`;
      if (!window.confirm(msg)) {
        return;
      }
    }

    let addressList = data.email;

    if (data.type !== 'Enfermedad' && data.type !== 'Evento') {
      //Obtén el responsable del departamento
      let responsableMail = null;
      const responsable = await getDocs(query(collection(db, 'users'), where('role', '==', 'Responsable'), where('departamento', '==', data.departamento)));

      if (responsable.empty) {
        responsableMail = prompt('No se ha encontrado un responsable para el departamento. Por favor, introduce el correo electrónico del responsable:');
      } else {
        responsableMail = responsable.docs[0].data().email;
      }

      if (responsableMail) {
        addressList = data.email + ',' + responsableMail;
      }
    }

    setLoading(true);

    if (data.type !== 'Enfermedad' && data.type !== 'Evento') {
      try {
        const response = await fetch('https://us-central1-controlhorario-4c249.cloudfunctions.net/serverMail/addCalendar', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + process.env.REACT_APP_SERVERMAIL_APIKEY,
          },
          body: JSON.stringify({
            addressList: addressList,
            subject: `Día libre ${data.iniciales}`,
            content: `<p>Se ha ACEPTADO tu solicitud de ${data.type.replace(/_/g, ' ')} para el día ${data.startDate}.</p>`,
            start: moment(data.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            end: moment(data.endDate, 'DD/MM/YYYY').add(1, 'days').format('YYYY-MM-DD'),
          }),
        });

        if (response.ok) {
          await updateDoc(doc(db, 'users', data.uid, 'ausencias', data.nid), { status: 'Aceptado' });
          await deleteDoc(doc(db, 'notifications', data.id));
          setData(null);
          setObservations('');
          ShowToast('Notificación enviada');
        } else {
          alert('No se ha podido añadir el evento al calendario. Por favor, revisa el correo del responsable para más información.');
          console.log('Error al añadir el evento al calendario:', response.statusText);
        }
      } catch (error) {
        alert('No se ha podido añadir el evento al calendario. Por favor, revisa el correo del responsable para más información.');
        console.error('Error al enviar el correo:', error);
      } finally {
        setLoading(false);
      }
    } else {
      try {
        //Actualiza los registros del usuario para marcar los días como enfermedad/evento
        updateRecords(data);

        const response = await fetch('https://us-central1-controlhorario-4c249.cloudfunctions.net/serverMail/sendMail', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + process.env.REACT_APP_SERVERMAIL_APIKEY,
          },
          body: JSON.stringify({
            to: data.email,
            subject: 'Solicitud de ' + data.type.replace(/_/g, ' ') + ' ACEPTADA',
            content: `<p>Se ha ACEPTADO tu solicitud de ${data.type.replace(/_/g, ' ')} para el día ${data.startDate}.</p>`,
          }),
        });

        if (response.ok) {
          await updateDoc(doc(db, 'users', data.uid, 'ausencias', data.nid), { status: 'Aceptado' });
          await deleteDoc(doc(db, 'notifications', data.id));
          setData(null);
          setObservations('');
          ShowToast('Notificación enviada');
        } else {
          alert('No se ha podido enviar el correo. Por favor, revisa el correo del responsable para más información.');
          console.log('Error al enviar el correo:', response.statusText);
        }
      } catch (error) {
        alert('No se ha podido enviar el correo. Por favor, revisa el correo del responsable para más información.');
        console.error('Error al enviar el correo:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  const deleteNotication = async (data) => {
    setLoading(true);
    try {
      const response = await fetch('https://us-central1-controlhorario-4c249.cloudfunctions.net/serverMail/sendMail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + process.env.REACT_APP_SERVERMAIL_APIKEY,
        },
        body: JSON.stringify({
          to: data.email,
          subject: 'Día libre RECHAZADO',
          content: `
          <p>Se ha RECHAZADO tu solicitud de ${data.type.replace(/_/g, ' ')} para el día ${data.startDate}.</p>
          ${observations !== '' ? `<hr /><p>Motivo del rechazo:</p><p>${observations}</p>` : ''}`,
        }),
      });

      if (response.ok) {
        await updateDoc(doc(db, 'users', data.uid, 'ausencias', data.nid), { status: 'Rechazado' });
        await deleteDoc(doc(db, 'notifications', data.id));
        setData(null);
        setObservations('');
        ShowToast('Notificación enviada');
      } else {
        alert('No se ha podido enviar el correo. Por favor, revisa el correo del responsable para más información.');
        console.log('Error al enviar el correo:', response.statusText);
      }
    } catch (error) {
      alert('No se ha podido enviar el correo. Por favor, revisa el correo del responsable para más información.');
      console.error('Error al enviar el correo:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!data) return null;

  return (
    <div className='content'>
      <h6>
        Solicitud de {data.type.replace(/_/g, ' ')}: <strong>{data.name}</strong>
      </h6>
      <hr />
      <div className='absence-item mt-4 mb-3'>
        <div className='card'>
          <div className='card-header d-flex align-items-center justify-content-between pe-5'>
            <h5 className='card-title mt-1'>{data.type.replace(/_/g, ' ')}</h5>
            <span>
              Año: <strong className='ms-2'>{data.year}</strong>
            </span>
          </div>
          <div className='card-body'>
            <div className='row mt-4'>
              <div className='col-md-3'>
                <div className='icon-calendar'>
                  <div id='weekday'>{moment(data.startDate, 'DD/MM/YYYY').format('MMM')}</div>
                  <div id='day'>{data.startDate.split('/')[0]}</div>
                </div>
                {data.startDate !== data.endDate && (
                  <>
                    <i className='fa-solid fa-arrow-right'></i>
                    <div className='icon-calendar'>
                      <div id='weekday'>{moment(data.endDate, 'DD/MM/YYYY').format('MMM')}</div>
                      <div id='day'>{data.endDate.split('/')[0]}</div>
                    </div>
                  </>
                )}
              </div>
              <div className='col-md-5'>
                <p className='card-text'>{`Del ${data.startDate} al ${data.endDate}`}</p>
                <p>
                  <strong className='me-2'>Observaciones:</strong>
                  {data.description}
                </p>
              </div>
              <div className='col-md-2 mt-4 text-center'>
                <p className='card-text '>
                  {data.type === 'Vacaciones'
                    ? Math.floor(data.total / 60)
                        .toString()
                        .padStart(2, '0') +
                      'h ' +
                      (data.total % 60).toString().padStart(2, '0') +
                      'min'
                    : moment(data.endDate, 'DD/MM/YYYY').diff(moment(data.startDate, 'DD/MM/YYYY'), 'days') + 1 + ' días'}
                </p>
              </div>
              <div className='col-md-2 mt-4 text-end pe-4'>
                <div className={`badge rounded-pill ${data.status}`}>
                  <i className={`fa-solid fa-clock-rotate-left ${data.status}`}></i>
                  <span className='text-white'>{data.status}</span>
                </div>
              </div>
            </div>
            {existingRecords?.length > 0 && (
              <div className='mt-4 mb-3 '>
                <i className='fa-solid fa-triangle-exclamation me-2 mt-1 fs-5 text-warning'></i>
                <strong className='me-2'>Registros de fichaje existentes:</strong>
                El usuario tiene fichajes registrados en {existingRecords.length === 1 ? 'el día' : 'los días'}:{' '}
                <strong className='text-danger'>{existingRecords.join(', ')}</strong>
                <small className='text-muted'>. Ten en cuenta que estos registros coinciden con las fechas de la solicitud de ausencia.</small>
              </div>
            )}
          </div>
          <div className='card-footer mt-2'>
            <div className='mb-3'>
              <label for='observations' className='form-label'>
                Observaciones
              </label>
              <textarea className='form-control' id='observations' rows='3' onChange={(e) => setObservations(e.target.value)}></textarea>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-footer pe-0'>
        <p>¿Desea aceptar la solicitud?</p>
        <button className='btn btn-success' disabled={loading} onClick={() => confirmNotification(data)}>
          {' '}
          Confirmar
        </button>
        <button className='btn btn-danger' disabled={loading} onClick={() => deleteNotication(data)}>
          {' '}
          Rechazar
        </button>
      </div>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            backdropFilter: 'blur(2px)',
            zIndex: 9999,
          }}
        >
          <style>{`.loader-container p { color: #fff !important; font-weight: 500; font-size: 1.1rem; }`}</style>
          <Loader type={simpleClock} loop={true} width='100px' />
        </div>
      )}
    </div>
  );
};
